export enum IncidentOperation {
    CREATE = 'operation.entity.incident.create',
    CLOSE = 'operation.entity.incident.close',
    ATTACH = 'operation.entity.incident.attach',
    PRINT = 'operation.entity.incident.print'
}
